import { IMaskInput } from 'react-imask'

import { cn } from '@/shared/utils/cn'

interface PhoneInputProps {
  id?: string
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  disabled?: boolean
  invalid?: boolean
  'aria-describedby'?: string
  'aria-invalid'?: true
}

// Единственное место с маской телефона. Список доступных стран задаётся
// на бэке (config/sms.php); при расширении добавлять маски здесь.
export function PhoneInput({ value, onChange, invalid, ...props }: PhoneInputProps) {
  return (
    <IMaskInput
      mask="+7 (000) 000-00-00"
      placeholder="+7 (999) 123-45-67"
      type="tel"
      value={value}
      onAccept={(_value, mask) => onChange(mask.unmaskedValue ? `+7${mask.unmaskedValue}` : '')}
      className={cn(
        'h-9 w-full rounded-md border bg-[var(--panel)] px-3 text-sm text-[var(--color-text)] placeholder:text-[var(--color-text-muted)] transition focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50',
        invalid
          ? 'border-[var(--color-danger)] focus-visible:ring-[var(--color-danger)]'
          : 'border-[var(--panel-border)] focus-visible:ring-[var(--color-brand)] focus-visible:border-[var(--color-brand)]',
      )}
      {...props}
    />
  )
}
